import React from "react";
import { useLocation } from "react-router-dom";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_M3_KMP = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <DAAModuleSubtopic
      title="KMP Algorithm - Knuth-Morris-Pratt String Matching"
      videos={["https://www.youtube.com/embed/V5-7GzOfADQ", "https://www.youtube.com/embed/q4_90fOoS-s"]}
      takeaways={[
        { text: "Don't go directly to the algorithm; instead, study the conceptual point of KMP and understand the use of the LPS table before studying the algorithm." },
        { text: "Both numerical and theoretical questions may be asked on KMP." },
      ]}
      questions={[
        "Find out the longest proper prefix that is also the proper suffix for the given pattern.",
        "Calculate the LPS table of the pattern.",
        "Values of i, j after certain iterations.",
        "Practical applications of string-matching algorithms in real-world scenarios.",
        "Comparison between the naive string-matching algorithm and the KMP string-matching algorithm, highlighting the drawbacks of the naive approach that are overcome by KMP.",
      ]}
      exampleVideos={[]}
      subtopics={subtopics}
      subjectPath={subjectPath}
    />
  );
};

export default DAA_M3_KMP;
